import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { CommonService } from "../common.service";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";
import { BaseService } from "./base.service";
import {SignalRConnection} from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { WidgethelperService } from "../widgethelper.service";

@Injectable()
export class PickedunitsthroughputService extends BaseService {

  private hub: SignalRConnection;
  labelSetting = {
    normal: {
      show: true,
      position: "outside",
      offset: [10, 0],
      textStyle: {
        fontSize: 18,
        fontFamily: "lato",
        color: "#ccc"
      }
    }
  };

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {super(); }

  chartOptionsThrouput() {
    return {
      title: {
        text: "",
        textStyle: {
          color: "#fff"
        }
      },
      grid: {
        top: '10%',
        left: '100',
        bottom: '75'
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: '5%',
        textStyle: {
          color: "#fff"
        }
      },
      xAxis: {
        type: "category",
        data: [],
        nameTextStyle: {
          color: "#fff"
        },
        axisLabel: {
          interval: 0,
          length: "100%",
          rotate: 30,
          color: "#fff"
        },
        splitArea: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        },
      },
      yAxis: {
        // name: '',
        // nameLocation: 'middle',
        // nameGap: 35,
        // nameRotate: 90,
        splitLine: {
          show: false
        },
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#fff"
          }
        }
      },
      series: [
        {
          name: "Picked Units Throughput %",
          type: "line",
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log("Picked Units Throughput");
    widget.dataLoaded = false;
    widget.errorMessage = "Retrieving records. Please wait...";
    let currentDateTime = moment()
      .toDate()
      .getTime();
    widget.Title = "Picked Units Throughput";
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor("broadcastUserActivity").subscribe(
          (data: any) => {
            console.log("broadcastUserActivity", data);
            let result: Array<any> = [];
            result = data;
            //need to format this
            let resultwid;
            let resultcreationtime;
            let lastUpdatedTime;

            if (result && result.length > 0) {
              //console.log(result[0].IsNoDataFound);
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            }
            else {
              widget.errorMessage = errorMessages.noWidgetData;
            }

            if (
              resultwid == widget.widgetId &&
              resultcreationtime == widget.widgetcreationtime &&
              !widget.IfNoDataFound
            ) {
              widget.dataLoaded = false;
              widget.chartOptions = this.chartOptionsThrouput();
              widget.errorMessage = null;

              if(widget.IfNoDataFound){
                widget.errorMessage = errorMessages.noWidgetData;
              }else if (widget.IfNoDataFound == null) {
                widget.errorMessage = "Retrieving records. Please wait...";
              }
              else{
              let Report_Periods = [];
              let PickUnitsThroughput = [];

                for (let i = 0; i < result.length; i++) {
                  let rptdate = "";
                  rptdate = this._commonService.formatDate(
                    result[i].ReportDate,
                    appSettings.chartDayHrFormat2
                  );
                  if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                    Report_Periods.push(rptdate);
                  }

                  PickUnitsThroughput.push([rptdate, result[i].PickedUnitsThroughput.toFixed(2)]);
                }
            

              widget.chartOptions.series[0].data = PickUnitsThroughput;
              widget.chartOptions.xAxis.data = Report_Periods;
              this.addZoomBar(widget.chartOptions);
            }
          }
          widget.dataLoaded = true;
          this._commonService.lastUpdatedTime = lastUpdatedTime;
          },
          err => {
            console.log("listenFor broadcastUserActivity error", err);
          }
        );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PICKEDUNITSTHROUGHPUT";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptionsThrouput();

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        let widgetSettingParam = {
          WidgetType: "PICKEDUNITSTHROUGHPUT",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
              //nothing
            }
          });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PICKEDUNITSTHROUGHPUT";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "PICKEDUNITSTHROUGHPUT",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
              //nothing
            }
            console.log("deleteWidget PICKEDUNITSTHROUGHPUT RemoveWidget");
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/pickedunitsthroughput.service.ts